module.exports = __webpack_public_path__ + "c4e633943c2b97c22739690696e28f04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-ganbarimasu.png
// module id = 2090
// module chunks = 4